// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"0c1a1e20","247":"0c1a1e20","620":"0c1a1e20","735":"0c1a1e20"}[chunkId] + ".chunk.css";
};